module.exports = __webpack_public_path__ + "img/sd.fb658203.svg";